import React, { useState } from "react";
import styles from "./styles/InfoTitle.module.css";

function InfoTitle({
  titleSpecialStyle = {},
  message,
  title,
  type,
  movetoleft = false,
}) {
  const [showMessage, setshowMessage] = useState(false);

  return (
    <div
      className={
        type ? styles.info_title_container_small : styles.info_title_container
      }
    >
      <div
        onMouseEnter={() => setshowMessage(true)}
        onMouseLeave={() => setshowMessage(false)}
        className={type ? styles.info_title_small : styles.info_title}
      >
        <span style={titleSpecialStyle}> {title}</span>
        {showMessage ? (
          <div
            className={
              movetoleft ? styles.info_message_left : styles.info_message
            }
          >
            {message}
          </div>
        ) : null}
      </div>
    </div>
  );
}

export default InfoTitle;
